import * as React from "react";
import { Outlet, useNavigate } from "react-router-dom";

import {
  Box,
  Paper,
  Toolbar,
  Container,
  AppBar,
  Typography,
  useTheme,
} from "@mui/material";

export default function MinimalLayout(props) {
  const { className } = props;
  const navigate = useNavigate();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const move2Home = () => {
    navigate("/");
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="absolute"
        sx={{
          background: isDarkMode
            ? "linear-gradient(90deg, #0f172a 0%, #1e293b 100%)"
            : "linear-gradient(90deg, #ffffff 0%, #f8fafc 100%)",
          boxShadow: isDarkMode
            ? "0 1px 3px rgba(0,0,0,0.3)"
            : "0 1px 3px rgba(0,0,0,0.08)",
          borderBottom: isDarkMode ? "1px solid #334155" : "1px solid #e2e8f0",
        }}
      >
        <Toolbar>
          <Box
            onClick={move2Home}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: 1,
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/logo.png"}
              alt="Clue2App"
              style={{ height: "36px" }}
            />
            <Typography
              component="h1"
              variant="h6"
              sx={{
                fontWeight: 600,
                letterSpacing: "0.02em",
                color: isDarkMode ? "#e2e8f0" : "#1e293b",
              }}
            >
              Clue 2 App
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="main"
        sx={{
          background: isDarkMode
            ? "linear-gradient(180deg, #0f172a 0%, #1e293b 100%)"
            : "linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)",
          flexGrow: 1,
          height: "100dvh",
          overflow: "auto",
          overscrollBehavior: "contain",
        }}
      >
        <Toolbar />
        <Container
          id="main"
          sx={{
            ...className,
            mt: 4,
            mb: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "calc(100dvh - 128px)",
          }}
        >
          <Paper
            elevation={isDarkMode ? 0 : 3}
            sx={{
              p: 3,
              display: "flex",
              flexDirection: "column",
              borderRadius: "16px",
              background: isDarkMode ? "#1e293b" : "#ffffff",
              border: isDarkMode ? "1px solid #334155" : "none",
              boxShadow: isDarkMode
                ? "0 4px 20px rgba(0,0,0,0.3)"
                : "0 4px 20px rgba(0,0,0,0.08)",
            }}
          >
            <Outlet />
          </Paper>
        </Container>
      </Box>
    </Box>
  );
}
